// Core Libs
import React from 'react';
import ReactDOM from 'react-dom';

// Main Component
import { App } from './app';

// DOM Render
ReactDOM.render(
  <App />,
  document.getElementById('root'),
);

